import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    disableLibraryFilter: true,
    clearLibraryFilter: false,
    sesLibraryEditActiveState: false,
    sesWpEditActiveState: false,
    // Mirrors cfsSlice.cfsView - drives the header's SES view-switcher dropdown
    // (Statement / Workpaper / Library) the same way cfsView drives CFS's.
    sesView: { label: "Stockholders' Equity Statement", value: "Stockholders' Equity Statement" },
}

const sesSlice = createSlice({
    name: 'SESSLICE',
    initialState,
    reducers: {
        setDisableSesLibraryFilter(state, action) {
            state.disableLibraryFilter = action.payload;
        },
        setClearSesLibraryFilter(state, action) {
            state.clearLibraryFilter = action.payload;
        },
        setSesLibraryEditActiveState(state, action) {
            state.sesLibraryEditActiveState = !state.sesLibraryEditActiveState
        },
        setSesWpEditAcitveState(state, action) {
            state.sesWpEditActiveState = !state.sesWpEditActiveState
        },
        setSesViewHandler(state, action) {
            state.sesView = action.payload;
        }
    }
});

export const {
    setDisableSesLibraryFilter,
    setClearSesLibraryFilter,
    setSesLibraryEditActiveState,
    setSesWpEditAcitveState,
    setSesViewHandler
} = sesSlice.actions;

export default sesSlice;
